<template>
  <footer class="site-footer band--ink on-ink">
    <div class="container grid">
      <div class="about">
        <p class="name">Citron Digital</p>
        <p class="pitch">Le Gestionnaire Citron, logiciel de devis, factures et facturation électronique pour les TPE et les indépendants. Créé et maintenu par Franck Besson, à Toulouse.</p>
        <p class="contact">
          <a :href="'mailto:' + email">{{ email }}</a><br>
          <a :href="'tel:' + phoneIntl">{{ phone }}</a>
        </p>
      </div>

      <nav aria-label="Le logiciel">
        <h2>Gestionnaire Citron</h2>
        <ul>
          <li><router-link to="/gestionnaire-citron">Présentation</router-link></li>
          <li><router-link to="/gestionnaire-citron/devis-factures">Devis et factures</router-link></li>
          <li><router-link to="/gestionnaire-citron/facturation-electronique">Facturation électronique</router-link></li>
          <li><router-link to="/gestionnaire-citron/comptabilite">Encaissements et TVA</router-link></li>
          <li><router-link to="/gestionnaire-citron/achats-logistique">Achats et logistique</router-link></li>
          <li><router-link to="/gestionnaire-citron/export-comptable">Export comptable (FEC)</router-link></li>
          <li><router-link to="/gestionnaire-citron/statistiques">Statistiques</router-link></li>
          <li><router-link to="/gestionnaire-citron/clients-prospects">Clients et prospects</router-link></li>
        </ul>
      </nav>

      <nav aria-label="Guides">
        <h2>Guides</h2>
        <ul>
          <li v-for="article in guides" :key="article.slug"><router-link :to="article.path">{{ article.shortTitle }}</router-link></li>
          <li><router-link to="/blog">Tous les articles</router-link></li>
        </ul>
      </nav>

      <nav aria-label="Citron Digital">
        <h2>Citron Digital</h2>
        <ul>
          <li><router-link to="/site-web">Création de site vitrine</router-link></li>
          <li><router-link to="/logiciel">Logiciel sur mesure</router-link></li>
          <li><router-link to="/portfolio">À propos</router-link></li>
          <li><router-link to="/contact">Contact</router-link></li>
          <li><a :href="linkedin" rel="noopener">LinkedIn</a></li>
        </ul>
      </nav>
    </div>

    <div class="container">
      <div class="legal">
        <p>© 2020-{{ year }} Citron Digital, Franck Besson.</p>
        <p><router-link to="/mentions-legales">Mentions légales</router-link></p>
      </div>
    </div>
  </footer>
</template>

<script>
    import site from "@/content/site";
    import articles from "@/content/articles";

    // Libellés courts des guides pour le pied de page
    const SHORT_TITLES = {
      'facturation-electronique-2026-2027-calendrier-obligations': 'Calendrier 2026-2027',
      'factur-x-format-facture-electronique': 'Factur-X expliqué',
      'mentions-obligatoires-facture-2026': 'Mentions obligatoires',
      'facture-acompte-facture-finale': 'Acompte et facture finale',
      'fec-fichier-des-ecritures-comptables': 'Le fichier FEC',
    };

    export default {
        name: 'FooterComponent',
        data() {
          return {
            year: new Date().getFullYear(),
            email: site.email,
            phone: site.phone,
            phoneIntl: site.phoneIntl,
            linkedin: site.linkedin,
            guides: articles
                .filter(article => SHORT_TITLES[article.slug])
                .map(article => ({slug: article.slug, path: article.path, shortTitle: SHORT_TITLES[article.slug]})),
          }
        },
    }
</script>

<style lang="stylus" scoped>
@import '~/src/common/style/constants.styl';

.site-footer
  padding-top clamp(40px, 6vw, 72px)
  padding-bottom 28px
  margin-top 0

.grid
  display grid
  gap 36px 32px
  grid-template-columns 1fr
  padding-bottom 36px

.name
  font-family 'Calder-LC', 'Trebuchet MS', system-ui, sans-serif
  font-size 1.7rem
  margin 0 0 8px

.pitch
  max-width 38ch
  margin 0 0 16px
  color #C9D2EA

h2
  font-family system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif
  font-size 1rem
  font-weight 700
  margin 0 0 12px

ul
  list-style none
  margin 0
  padding 0

li
  margin 0 0 8px
  padding 0

// Liens du pied de page : pas de soulignement (trop chargé sur fond sombre). On les reconnaît à leur blanc plus net que le texte
// courant, au chevron citron des listes et au surlignage citron au survol ou au clavier.
.site-footer a
  text-decoration none
  font-weight 600
  &:hover, &:focus-visible
    background-color LEMON
    color INK

nav li a
  display inline-block
  &::before
    content '›'
    margin-right 0.5em
    color LEMON
    font-weight 700
  &:hover::before, &:focus-visible::before
    color INK

.legal
  display flex
  flex-wrap wrap
  justify-content space-between
  gap 8px 24px
  padding-top 20px
  border-top 1px solid rgba(255, 255, 255, 0.22)
  font-size 0.9rem
  p
    margin 0
    color #C9D2EA

@media (min-width: TABLET_SIZE)
  .grid
    grid-template-columns 1fr 1fr

@media (min-width: DESKTOP_SIZE)
  .grid
    grid-template-columns 1.4fr 1fr 1fr 1fr
</style>
